<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>
<div class="container-fluid bg-img-v4">
<div [hidden]="skelition" class="row custom-margin">
    <div class="col-md-8 col-12 p-0">
        <div class="container mb-4">
            <app-no-data *ngIf="data.length == 0 && !skelition"></app-no-data>
            <app-table [unit]="'OU_TYPE'" *ngIf="data.length > 0" [data]="data" (actionCall)="actionCall($event)"></app-table>
        </div>
    </div>

    <div class="col-md-4 col-12 p-0 my-3" *ngIf="permissionService.hasPermission('OU_TYPE','c')">
        <div class="container mb-5">
            <h2 class="text-center color-ms-purple my-4"><i style="font-size: 2rem; font-weight: 600;" class="pi pi-fw pi-plus-circle color-ms-purple mx-2"></i>
                {{"Create a type" | translator}}
            </h2>
            <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
            <p-messages [(value)]="messages" [enableService]="false"></p-messages>
        </div>
    </div>
</div>
</div>
<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions> 

<!-- Confirm Modal -->
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>


<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false"header="Header" [(visible)]="updateModal" [style]="{ margin: '0rem 1rem' }">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold"></span>
        {{ "Update type" | translator}}
    </ng-template>
    <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions" (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>


<app-footer></app-footer>